module.exports = __webpack_public_path__ + "img/gallagher-logo-flat.fe378eb2.png";